import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { type BaseEvent, BaseEventRuntype } from './base';
import { CoreEventRuntype } from './core';
import { ClickstreamEventEnum } from 'bc-model';

const NoticeSnoozedBrowserRunType = BaseEventRuntype.And(
  Record({ noticeKey: String, noticeType: String, version: Literal(1) })
);
const NoticeSnoozedServerRunType = NoticeSnoozedBrowserRunType.And(CoreEventRuntype).And(
  Record({ sessionId: String })
);

type NoticeSnoozedBrowserEvent = Static<typeof NoticeSnoozedBrowserRunType>;
type NoticeSnoozedServerEvent = Static<typeof NoticeSnoozedServerRunType>;

const isNoticeSnoozedServerEvent = (obj: BaseEvent): obj is NoticeSnoozedServerEvent => {
  return obj.event === ClickstreamEventEnum.NOTICE_SNOOZED;
};

export {
  isNoticeSnoozedServerEvent,
  NoticeSnoozedBrowserRunType,
  NoticeSnoozedServerRunType,
  NoticeSnoozedBrowserEvent,
  NoticeSnoozedServerEvent,
};
